import lodashCompact from 'lodash/fp/compact';
import pluralize from 'pluralize';

import moment from 'moment';
import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';

export const getDuration = (interval) => {
  if (!interval) {
    return null;
  }
  const { days, hours, minutes } = interval;
  return lodashCompact([
    days ? `${days} ${pluralize('day', days, false)}` : '',
    hours ? `${hours} ${pluralize('hour', hours, false)}` : '',
    minutes ? `${minutes} ${pluralize('minute', minutes, false)}` : '',
  ]).join(' ');
};

export const getFormattedDateTime = (timestamp) => {
  if (!timestamp) {
    return null;
  }
  return momentWithAustinTimezone(timestamp).format('hh:mma MMM DD, YYYY');
};

export const getDurationString = ({ startTimestamp, endTimestamp, separator = ' ' }) => {
  if (
    !startTimestamp ||
    typeof startTimestamp !== 'string' ||
    (endTimestamp && typeof endTimestamp !== 'string')
  ) {
    return '';
  }

  const startMoment = momentWithAustinTimezone(startTimestamp);
  const endMoment = endTimestamp
    ? momentWithAustinTimezone(endTimestamp)
    : momentWithAustinTimezone();

  const diffInSeconds = endMoment.diff(startMoment, 'seconds');
  const hourMinuteDiff = moment
    .utc(moment.duration(diffInSeconds, 'seconds').asMilliseconds())
    .format('HH:m');
  const [hourDiff, minutesDiff] = hourMinuteDiff.split(':');
  const dayDiff = endMoment.diff(startMoment, 'days');

  const days = dayDiff > 0 ? `${dayDiff}d` : null;

  const hours = hourDiff > 0 ? `${hourDiff}hr` : null;

  const minutes = `${minutesDiff}m`;

  return lodashCompact([days, hours, minutes]).join(separator) || '';
};
